function impression({ pnrCode, route, promotions }) {
  return {
    event: 'promotionImpression',
    pnr: pnrCode,
    route: route,
    ecommerce: {
      promoView: {
        promotions: _getPromotions(promotions),
      },
    },
  };
}

function click({ pnrCode, route, promotions }) {
  return {
    event: 'promotionClick',
    pnr: pnrCode,
    route: route,
    ecommerce: {
      promoClick: {
        promotions: _getPromotions(promotions),
      },
    },
  };
}


function _getPromotions(promos) {
  const promotions = [];
  if (promos && Array.isArray(promos)) {
    promos.forEach((promotion)=>{
      const onePromo = {
        id: promotion.id ? promotion.id : 'NA',
        name: promotion.name ? promotion.name : 'NA',
        creative: promotion.creative ? promotion.creative : 'NA',
        position: promotion.position ? promotion.position : 'MYB',
      };
      promotions.push(onePromo);
    });
  }
  return promotions;
}

export default {
  click,
  impression,
};
